const OTP_API_URL = "https://dge.algores.it/api/otp.php";

export async function richiediOTP(email, eventoId) {
  const response = await fetch(OTP_API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ azione: "richiediOTP", email, eventoId }),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || "Errore invio OTP");
  return data;
}

export async function verificaOTP(email, eventoId, otp) {
  const response = await fetch(OTP_API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ azione: "verificaOTP", email, eventoId, otp }),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || "Codice non valido");
  return data;
}

export async function verificaSessione(token, eventoId) {
  const response = await fetch(OTP_API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ azione: "verificaSessione", token, eventoId }),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || "Sessione non valida");
  return data;
}

export async function richiediOTPCorso(email, corsoId) {
  const response = await fetch(OTP_API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ azione: "richiediOTPCorso", email, corsoId }),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || "Errore invio OTP");
  return data;
}

export async function verificaOTPCorso(email, corsoId, otp) {
  const response = await fetch(OTP_API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ azione: "verificaOTPCorso", email, corsoId, otp }),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || "Codice non valido");
  return data;
}

export async function verificaSessioneCorso(token, corsoId) {
  const response = await fetch(OTP_API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ azione: "verificaSessioneCorso", token, corsoId }),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || "Sessione non valida");
  return data;
}

// Statistiche DEM (MailUp) per un evento, lette lato server: il report cliente pubblico non ha
// una sessione Firebase Auth e le regole Firestore gli negano la lettura delle credenziali
// MailUp in impostazioni/mailup — vedi il nuovo azione "statisticheDem" in otp.php.
export async function statisticheDem(token, eventoId) {
  const response = await fetch(OTP_API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ azione: "statisticheDem", token, eventoId }),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || "Errore recupero statistiche DEM");
  return data.statistiche;
}